import { Icon } from './Icon.jsx';
import { usePdf } from '../store/pdfStore.js';
import { useT } from '../i18n/index.js';

export function Sidebar({ onOpenSettings, onOpenHistory, onReset, onWipe, onClose }) {
  const t = useT();
  const fileName = usePdf((s) => s.fileName);
  const pages = usePdf((s) => s.pages);
  const exportsCount = usePdf((s) => s.exports.length);

  const pagesLabel = pages.length > 1
    ? t('sidebar.pages_count_plural', { n: pages.length })
    : t('sidebar.pages_count', { n: pages.length });

  return (
    <aside className="sidebar">
      <div className="sidebar-section">
        <div className="sidebar-title">{t('sidebar.document')}</div>
        {fileName ? (
          <div className="sidebar-file">
            <Icon name="doc" size={18} />
            <div style={{ minWidth: 0 }}>
              <div className="name" title={fileName}>{fileName}</div>
              <div className="meta">{pagesLabel}</div>
            </div>
          </div>
        ) : (
          <div className="muted tiny">{t('sidebar.no_file')}</div>
        )}
        {fileName && (
          <button className="btn sm ghost" onClick={onClose}>
            <Icon name="close" size={14} /> {t('sidebar.close_doc')}
          </button>
        )}
      </div>

      <div className="sidebar-section">
        <div className="sidebar-title">{t('sidebar.configuration')}</div>
        <div className="tool-list">
          <button className="tool" onClick={onOpenSettings}>
            <Icon name="settings" size={16} /> {t('sidebar.preferences')}
          </button>
          <button className="tool" onClick={onOpenHistory}>
            <Icon name="history" size={16} /> {t('sidebar.history')}
            {exportsCount > 0 && <span className="badge">{exportsCount}</span>}
          </button>
        </div>
      </div>

      <div className="sidebar-section">
        <div className="sidebar-title">{t('sidebar.backup')}</div>
        <div className="tool-list">
          <button className="tool" onClick={onReset}>
            <Icon name="reset" size={16} /> {t('sidebar.reset')}
          </button>
          <button className="tool" onClick={onWipe} style={{ color: '#ffb0bf' }}>
            <Icon name="trash" size={16} /> {t('sidebar.wipe')}
          </button>
        </div>
      </div>

      <div className="sidebar-section" style={{ marginTop: 'auto' }}>
        <div className="tiny muted">{t('sidebar.privacy')}</div>
      </div>
    </aside>
  );
}
